import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRestaurant } from '../contexts/RestaurantContext.jsx';
import { selectAppSettings } from '../app/appSettingsSlice.js';
import { getThemeColor } from '../utils/themeUtils';

/**
 * Hook to set global CSS variables for theme colors
 * This ensures CSS can access theme colors via var(--theme-color)
 * Should be called once at the app root level (inside RestaurantProvider).
 */
const useGlobalThemeColors = () => {
  const { restaurantSlug } = useRestaurant();
  const appTheme = useSelector((state) =>
    selectAppSettings(state, restaurantSlug).appTheme
  );

  useEffect(() => {
    if (appTheme) {
      const themeColor = getThemeColor(appTheme);
      
      // Set CSS variables on document root
      document.documentElement.style.setProperty('--theme-color', themeColor);
      document.documentElement.style.setProperty('--theme-color-light', `${themeColor}dd`);
      document.documentElement.style.setProperty('--theme-color-dark', `${themeColor}bb`);
      document.documentElement.style.setProperty('--theme-color-opacity-10', `${themeColor}1a`);
      document.documentElement.style.setProperty('--theme-color-opacity-20', `${themeColor}33`);
      document.documentElement.style.setProperty('--theme-color-opacity-40', `${themeColor}66`);
      document.documentElement.style.setProperty('--theme-color-opacity-60', `${themeColor}99`);
    }
  }, [appTheme]);
};

export default useGlobalThemeColors;

